import { prepareGuestLinkMember } from '../member';
import { prepareInvitationCommon } from './prepare-invitation-common';
export const prepareGuestLinkInvitation = async ({ adminCrypto, workspaceId, }) => {
    const [adminKeys, workspaceCommonKey, everyoneKeys, workspaceSecretKey] = await Promise.all([
        adminCrypto.verifyAndGetAdminKeys(),
        adminCrypto.getWorkspaceCommonKey(),
        adminCrypto.verifyAndGetEveryoneKeys(),
        adminCrypto
            .getSsoCrypto()
            .then((ssoCrypto) => ssoCrypto.verifyAndGetSsoSecretKey()),
    ]);
    const invitationParams = {
        adminKeys,
        workspaceCommonKey,
        everyonePrivateKey: everyoneKeys.privateKey,
        workspaceId,
        workspaceSecretKey,
    };
    const { invitation, invitationKeys, invitationSecret } = await prepareInvitationCommon(invitationParams);
    const member = await prepareGuestLinkMember({
        workspaceId,
        invitationKeys,
    });
    return { invitation: { ...invitation, member }, invitationSecret };
};
